import {
    SidebarBody,
    SidebarButton,
    SidebarButtonsGroup,
    SidebarSeparator,
    SidebarSlot,
    SidebarWrapper
} from '@/components/ui/sidebar-atoms/SidebarAtoms'
import {useTranslation} from '@/translations/i18n'
import {StyledAccountModalSidebarHeader, StyledSidebarContainer} from './style'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useAccountStore} from '@/features/account/store/useAccountStore'

export const AccountModalSidebar = () => {
    const {t} = useTranslation()

    const modalView = useAccountStore(state => state.modalView)
    const setModalView = useAccountStore(state => state.setModalView)

    return (
        <SidebarWrapper>
            <StyledAccountModalSidebarHeader>
                <h2> {t('commons:your_account')}</h2>
            </StyledAccountModalSidebarHeader>
            <SidebarBody>
                <StyledSidebarContainer>
                    <SidebarSeparator />
                </StyledSidebarContainer>
                <SidebarSlot>
                    <Flexbox direction="column" gap={3} fullWidth>
                        <SidebarButtonsGroup>
                            <SidebarButton
                                variant={modalView == 'profile' ? 'secondary' : 'ghost'}
                                onClick={() => setModalView('profile')}
                            >
                                {t('commons:profile')}
                            </SidebarButton>
                            <SidebarButton
                                variant={modalView == 'availability' ? 'secondary' : 'ghost'}
                                onClick={() => setModalView('availability')}
                            >
                                {t('commons:availability')}
                            </SidebarButton>
                        </SidebarButtonsGroup>
                        <SidebarSeparator />
                    </Flexbox>
                </SidebarSlot>
            </SidebarBody>
        </SidebarWrapper>
    )
}
